export class CountMatch {
    proposal_matchs: number;
    search_matchs: number;

    constructor() {
        this.proposal_matchs = 0;
        this.search_matchs = 0;
    }
}